export default __webpack_public_path__ + "static/media/icon-linkedin-link.2a8a2a1c.svg";